@if (
  formType === FormType.Projektbidrag ||
  formType === FormType.ChangeRequest ||
  formType === FormType.ProjektparterBudget
) {
  <lib-question-projektbidrag-budget
    [questionForm]="questionForm"
    [repeaterGroupId]="repeaterGroupId"
    [formBuilder]="formBuilder"
    [question]="question"
  ></lib-question-projektbidrag-budget>
} @else if (formType === FormType.Skiss) {
  <lib-question-skiss-budget
    [questionForm]="questionForm"
    [repeaterGroupId]="repeaterGroupId"
    [question]="question"
  ></lib-question-skiss-budget>
} @else if (
  formType === FormType.ProgressReport || formType === FormType.EndReport
) {
  <lib-question-upparbetade-kostnader
    [questionForm]="questionForm"
    [repeaterGroupId]="repeaterGroupId"
    [question]="question"
    [showAterbetalningskrav]="formType === FormType.EndReport"
  ></lib-question-upparbetade-kostnader>
} @else if (
  ![
    FormType.Projektbidrag,
    FormType.Skiss,
    FormType.ProgressReport,
    FormType.EndReport,
    FormType.ChangeRequest,
  ].includes(formType)
) {
  <span>Formulärtypen {{ formType }} stöder inte budget</span>
}
